import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";

const InternalService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Find/Find%20API
  find: async function (search) {
    try {
      const path = `/api/v1/find/`;
      const params = {
        search,
      };
      return await RequestService.get(path, params);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Internal/Ticketing%20Checkin%20Callback
  checkin: async function (data) {
    try {
      const path = `/api/v1/integrations/ticketing/checkin/`;
      return await RequestService.post(path, data);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Ticketing%20Integration/Get%20Ticketing%20Events
  getTicketingEvents: async function (organizationId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/integrations/ticketing/events/`;
      return await RequestService.get(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Ticketing%20Integration/Get%20Ticketing%20Ticket%20Types
  getTicketingEventTicketTypes: async function (organizationId, eventId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/integrations/ticketing/ticket-types/`;
      return await RequestService.get(path, filters);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default InternalService;
